import { ReactKeycloakProvider } from "@react-keycloak/web";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import App from "./components/app/App";
import keycloak from "./keycloak";
import Reducer from "./store/rootReducer";
import SwitchTheme from "./themes/SwitchTheme";

declare global {
  namespace NodeJS {
    interface ProcessEnv {
      REACT_APP_SERVER_URL: string;
      REACT_APP_KEYCLOAK_URL: string;
    }
  }
  interface Window {
    env: NodeJS.ProcessEnv;
  }
}

const initOptions = {
  onLoad: "check-sso" as const,
  silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
  checkLoginIframe: false,
  enableLogging: true,
};

const store = createStore(Reducer, applyMiddleware(thunk));
const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);
root.render(
  <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions}>
    <Provider store={store}>
      <SwitchTheme>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SwitchTheme>
    </Provider>
  </ReactKeycloakProvider>
);
